import { Container, Grid, Box, Link, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import OurCover from '../../Component/OurCover/OurCover';
import FaqScss from './Faq.module.scss';
import { FrequentlyData } from '../../Data/frequentlyData';
import Clients from '../../Component/Clients/Clients';
import resourcesImg from '../../Common/Image/skills.jpg';


function Faq() {
    return (
        <div>
            <OurCover ourHead="F.A.Q" title="" />
            {/* frequently */}
            <section id={FaqScss.frequently}>
                <Container maxWidth='lg'>
                    <Grid container>
                        <Box className={FaqScss.frequentlyHead}>
                            <p>frequently asked question</p>
                        </Box>
                        <Box className={FaqScss.frequentlyBox}>
                            {
                                FrequentlyData.map(freData =>
                                    <Accordion className={FaqScss.frequentlyItem} key={freData.id}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header" className={FaqScss.frequentlyItemHead}
                                        >
                                            <Typography>{freData.question}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={FaqScss.frequentlyItemFoot}>
                                            <Typography>
                                                {freData.answer}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            }
                        </Box>
                        <Box className={FaqScss.frequentlyAnyQuestion}>
                            <p>
                                If any other questions <Link href='#'>contact us</Link> from here
                            </p>
                        </Box>
                    </Grid>
                </Container>
            </section>
            {/* resources */}
            <section id={FaqScss.resources}>
                <Container maxWidth='lg'>
                    <Box className={FaqScss.resourcesHead}>
                        <span>Resources</span>
                        <h2>Find out more with Busin Software</h2>
                        <p>Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and specimen book.</p>
                    </Box>
                    <Grid container sx={{ mx: '-15px', width: 'auto' }} className={FaqScss.resourcesBody}>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={FaqScss.resourcesBodyItem}>
                                <img src={resourcesImg} alt=''></img>
                                <Box className={FaqScss.resourcesBodyItemAbsolute}>
                                    <span>pricing</span>
                                    <p>Lorem Ipsum has been the industrys standard</p>
                                    <Link href='#'>learn more</Link>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={FaqScss.resourcesBodyItem}>
                                <img src={resourcesImg} alt=''></img>
                                <Box className={FaqScss.resourcesBodyItemAbsolute}>
                                    <span>services</span>
                                    <p>Lorem Ipsum has been the industrys standard</p>
                                    <Link href='#'>learn more</Link>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={FaqScss.resourcesBodyItem}>
                                <img src={resourcesImg} alt=''></img>
                                <Box className={FaqScss.resourcesBodyItemAbsolute}>
                                    <span>support</span>
                                    <p>Lorem Ipsum has been the industrys standard</p>
                                    <Link href='#'>learn more</Link>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </section>
            {/* clients */}
            <Clients />
        </div>

    )
}

export default Faq;
